import { Outlet } from "react-router-dom";
import { StudentTopbar } from "../TopBar/TopBar";
// import { Navbar } from "../../../WebUi/Components/HomeV2/Navbar";

const Layout = ({ userType }) => {
  return (
    <div className="layout">
      <StudentTopbar userType={userType} />
      {/* <Navbar /> */}
      <Outlet context={{ userType }} />
    </div>
  );
};

export default Layout;
